import { css } from '@emotion/react'
import { spacing } from '../../../foundation/spacing'

export const GRID_CELL_IMAGE_SIZE = 40

const sharedStyles = css({
  marginTop: 0,
  marginLeft: spacing.X8,
  marginBottom: 0,
  marginRight: spacing.X8,
})

export const gridCellLoaderStyles = css(
  {
    height: GRID_CELL_IMAGE_SIZE,
    width: GRID_CELL_IMAGE_SIZE,
  },
  sharedStyles
)

export const gridCellImageStyles = css(
  {
    maxHeight: GRID_CELL_IMAGE_SIZE,
    maxWidth: GRID_CELL_IMAGE_SIZE,
    height: 'auto',
    width: 'auto',
  },
  sharedStyles
)
